module.exports = __webpack_public_path__ + "media/images/landing/icon-mail-drawing-f65d67e881e3c7b785e996a9d556b6bc.svg";